import { getLocation } from './ssrCompatible'

export const isLocalEnv =
  getLocation().host.indexOf('localhost') > -1 || isLocalIp()

export const getEnv = (ssrLocationParams) => {
  const curHost = getLocation(ssrLocationParams).host
  const matrixClusterName = process.env.MATRIX_CLUSTER_NAME || ''

  if (curHost.indexOf('localhost') > -1 || isLocalIp(ssrLocationParams)) {
    return 'test'
  } else if (
    curHost.indexOf('staging-') > -1 ||
    curHost.indexOf('-staging') > -1
  ) {
    return matrixClusterName ? 'previewSrv' : 'test'
  } else if (
    curHost.indexOf('preview-') > -1 ||
    curHost.indexOf('-preview') > -1
  ) {
    return matrixClusterName ? 'previewSrv' : 'preview'
  } else {
    // return matrixClusterName ? 'onlineSrv' : 'online'
    return 'online'
  }
}

export function isLocalIp(ssrLocationParams) {
  return !!getLocation(ssrLocationParams).hostname.match(
    /^127\.|10\.|192\.168|172\.(1[6-9]|2|3[01])$/
  )
}
